import { render, staticRenderFns } from "./CardSettlement.vue?vue&type=template&id=204b1bf5&scoped=true"
import script from "./CardSettlement.vue?vue&type=script&lang=js"
export * from "./CardSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b1bf5",
  null
  
)

export default component.exports